import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Card, CardTitle, CardText } from 'react-md'

import { getArtworkCount } from 'redux/reducers'
import * as actions from 'redux/actions'

class Dashboard extends Component {
  componentWillMount () {
    const { loadArtworkCount } = this.props
    loadArtworkCount()
  }

  render () {
    const { artworkCount } = this.props

    return (
      <div>
        <Card>
          <CardTitle title='Dashboard' />
          { artworkCount > 0 ? (
            <CardText>
              Currently, there are {artworkCount} active artworks.
            </CardText>
          ) : (
            <CardText>
              No artworks yet.
            </CardText>
          ) }
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  artworkCount: getArtworkCount(state)
})

export default connect(mapStateToProps, actions)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js